var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationActiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 117 117",
    style: {
      enableBackground: "new 0 0 117 117"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.location-active-icon-0{fill:#0E2654;}\r\n\t.location-active-icon-1{fill:#D9D9D9;}\r\n\t.location-active-icon-2{opacity:0.3;fill:#FFFFFF;}\r\n\t.location-active-icon-3{fill:#FFFFFF;}\r\n\t.location-active-icon-4{fill:#FF4500;}\r\n\t.location-active-icon-5{fill:#31FF77;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_35"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_34"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_33"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_32"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_31"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_30"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_29"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_28"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "location-active-icon-3",
    d: "M92.6,79.4l-31.4,35.5c-3.1,3-8.1,2.8-10.9-0.4L22.8,77.9l0.1-0.1c-7.2-8.2-11.5-19-11.5-30.8 c0-26,21.1-47,47-47s47,21.1,47,47C105.5,59.6,100.6,71,92.6,79.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "location-active-icon-4",
    d: "M81.1,46.4c0.5,2.3-0.9,21.2-18.9,24.1c-18.4,2.9-24.7-13.4-24.7-13.4S31.2,41.7,43,31.2s25.2-3.6,25.2-3.6 L82,15.4c-23.8-16.2-45.1-1.5-45.1-1.5c-12,6.6-19.6,23.4-18.8,36.1c0.2,2.7,0.7,5.3,1.3,7.7c1.9,7,5.5,13.4,10.4,18.8l18.6,20.7 c0.7,0.8,1.4,1.6,2.1,2.4c0.8,0.9,2.5,2.5,4.9,2.6c3.4,0.2,5.5-1.9,5.5-1.9l26-23.5c0,0,10.1-8.8,11.7-25.1c1.9-19-10.8-31-10.8-31 L63.4,42.3c-3.2,2.8-3.4,7.7-0.6,10.8l0,0c2.8,3.1,7.6,3.3,10.7,0.4L81.1,46.4z"
  }))), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_26"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_25"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_24"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_23"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_22"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_21"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_20"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_19"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_18"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_17"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_16"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  })), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  })), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_13"
  })), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_12"
  })), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11"
  })), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_10"
  })), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  })), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  })), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationActiveIcon);
export default __webpack_public_path__ + "static/media/location-active-icon.d972ff48.svg";
export { ForwardRef as ReactComponent };